import Handler from './Handler.js'

export default {
  configure ({key, token, hostedPageRedirect}) {
    return new Handler(key, token, hostedPageRedirect)
  }
}



// WEBPACK FOOTER //
// ./src/api/components/multipay/index.js